import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SaveButton from 'src/components/app/SaveButton';
import { useSnackbar } from 'notistack';
import $api from 'src/components/http';
import { Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = (props) => {
  const { t } = useTranslation();
  const {
    title,
    content,
    actionUrl,
    open,
    onSubmit,
    onClose,
    item
  } = props;
  const [isLoading, setIsLoading] = useState();
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    const url = `${actionUrl}/${item.id}`;
    $api.delete(url)
      .catch((err) => {
        setIsLoading(false);
        if (err.response && err.response.data && err.response.data.message){
          enqueueSnackbar(err.response.data.message, {
              variant: 'error'
          });
        } else {
            enqueueSnackbar(err.toString(), {
                variant: 'error'
            });
        }
        onSubmit({});
        handleClose();
        console.log('err: ', err);
        return null;
      })
      .then((res) => {
        if (res) {
          if (res.status !== 200 && res.status !== 204) {
            return Promise.reject();
          }
          return res;
        }
      })
      .then((data) => {
        onSubmit(data);
        handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle sx={{ borderBottom: '0 none' }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ borderTop: '0 none' }}>
        
        <SaveButton
          onClick={handleSubmit}
          color="error"
          variant="contained"
          disableElevation
          startIcon={<Delete />}
          autoFocus
          loading={isLoading}
          label="Remove"
        />
        <Button onClick={handleClose} variant="outlined" color="primary">
          {t('Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  actionUrl: PropTypes.string,
  open: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  item: PropTypes.object
};

export default ConfirmDialog;
